module.exports = __webpack_public_path__ + "static/media/binary-1538721_640.71e2d4f4.jpg";